var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesmoj02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.97 15.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1a371b;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.89,
    y: 0.73,
    width: 5.16,
    height: 7.5,
    transform: "translate(4.47 -1.85) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.79,
    y: 4.09,
    width: 14.68,
    height: 7.5,
    transform: "translate(27.96 4.1) rotate(135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesmoj02);
export default __webpack_public_path__ + "static/media/icones moj-02.3663e3ee6ff251e949187aefd2c63843.svg";
export { ForwardRef as ReactComponent };